import __request__ from "routing/request";
export function regions(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.llm/bedrock/regions", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
